import React from 'react';
import { LoadingSpinner, Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import { PsBeaconModal } from '../shared/BeaconRegister';

const SessionLogoutLoader = () => {
    return (
        <PsBeaconModal id="session-logout-loader-modal">
            <Box
                id="session-timer-container"
                className="beacon-on-light beacon-theme-modern-outlook">
                <Typography
                    type="headline" scale={300} bold
                    sx={{ paddingBottom: '8px' }}>
                    Logging out...
                </Typography>
                <Typography type="body" scale={100}>
                    One moment while we log out your account...
                </Typography>
                <LoadingSpinner id="session-logout-loader" />
            </Box>
        </PsBeaconModal>
    );
};

export default SessionLogoutLoader;
